module.exports = __webpack_public_path__ + "img/regalo2.0e633fc7.png";